import React, { useState } from 'react'
import { useForm, SubmitHandler, Controller } from 'react-hook-form'
// import { yupResolver } from '@hookform/resolvers/yup'
// import * as yup from 'yup'
import {
    Button,
    FormControl,
    IconButton,
    InputAdornment,
    InputLabel,
    OutlinedInput,
} from '@mui/material'
import swal from 'sweetalert'
import api from '../../services/axios'
import { Container, Header, Form } from './styles'
import { useDispatch } from 'react-redux'
import { loginFailure } from '../../store/modules/auth/actions'
import { initialMenu } from '../../store/modules/menu/actions'
import { Visibility, VisibilityOff } from '@mui/icons-material'

interface Inputs {
    senhaAtual: string
    senhaNova: string
    senhaNovaConfirmacao: string
}

// const schema = yup.object({
//     senhaAtual: yup.string().required().min(6).max(32),
//     senhaNova: yup.string().required().min(6).max(32),
//     senhaNovaConfirmacao: yup.string().required().min(6).max(32),
// }).required()

const Senha: React.FC = () => {
    const dispatch = useDispatch()
    const {
        handleSubmit,
        control,
        formState: { errors },
        getValues,
    } = useForm<Inputs>()

    const submit: SubmitHandler<Inputs> = async (inputs) => {
        try {
            await api.put('/minhaconta/senha/alterar', inputs)
            swal({
                title: 'Sua senha foi alterada com sucesso!',
                text: `Por favor, entre novamente na sua conta!`,
                icon: 'success',
            }).then(() => {
                dispatch(loginFailure())
                dispatch(initialMenu())
            })
        } catch (error) {
            swal({
                title: 'Ocorreu um erro ao alterar sua senha!',
                text: `Por favor, verifique os campos e tente novamente!`,
                icon: 'error',
            })
        }
    }

    return (
        <Container>
            <Header>
                <h2>Atualize sua senha</h2>
            </Header>

            <Form onSubmit={handleSubmit(submit)}>
                <div className="input-wrapper">
                    <Controller
                        defaultValue=""
                        name="senhaAtual"
                        control={control}
                        rules={{
                            required: 'A senha atual é obrigatória',
                            minLength: 6,
                            maxLength: 32,
                        }}
                        render={({ field }) => (
                            <InputSenha
                                label="Senha atual"
                                id="senhaAtual"
                                field={field}
                                autoComplete="current-password"
                            />
                        )}
                    />
                    {errors.senhaAtual && (
                        <span>
                            {errors.senhaAtual.message ||
                                'A senha deve ter entre 6 e 32 caracteres.'}
                        </span>
                    )}
                </div>

                <div className="input-wrapper">
                    <Controller
                        defaultValue=""
                        name="senhaNova"
                        control={control}
                        rules={{
                            required: 'A nova senha é obrigatória',
                            minLength: 6,
                            maxLength: 32,
                        }}
                        render={({ field }) => (
                            <InputSenha
                                label="Nova senha"
                                id="novaSenha"
                                field={field}
                                autoComplete="new-password"
                            />
                        )}
                    />
                    {errors.senhaNova && (
                        <span>
                            {errors.senhaNova.message ||
                                'A senha deve ter entre 6 e 32 caracteres.'}
                        </span>
                    )}
                </div>

                <div className="input-wrapper">
                    <Controller
                        defaultValue=""
                        name="senhaNovaConfirmacao"
                        control={control}
                        rules={{
                            required: 'Por favor, confirme a senha',
                            minLength: 6,
                            maxLength: 32,
                            validate: {
                                matchesPreviousPassword: (value) => {
                                    const { senhaNova } = getValues()
                                    return (
                                        senhaNova === value ||
                                        'As senhas precisam ser iguais'
                                    )
                                },
                            },
                        }}
                        render={({ field }) => (
                            <InputSenha
                                label="Confirmação"
                                id="confirmacaoNovaSenha"
                                field={field}
                                autoComplete="new-password"
                            />
                        )}
                    />
                    {errors.senhaNovaConfirmacao && (
                        <span>
                            {errors.senhaNovaConfirmacao.message ||
                                'A senha deve ter entre 6 e 32 caracteres.'}
                        </span>
                    )}
                </div>
                <div className="actions">
                    <Button variant="contained" type="submit">
                        Alterar
                    </Button>
                </div>
            </Form>
        </Container>
    )
}

export default Senha

interface PropsSenha {
    label: string
    id: string
    field: any
    autoComplete: string
}

const InputSenha = ({ label, id, field, autoComplete }: PropsSenha) => {
    const [showPassword, setShowPassword] = useState(false)

    function handleClickShowPassword() {
        setShowPassword(!showPassword)
    }
    return (
        <FormControl {...field} sx={{ width: '100%' }} variant="outlined">
            <input type="hidden" name="username" autoComplete="username" />
            <InputLabel htmlFor={id}>{label}</InputLabel>
            <OutlinedInput
                id={id}
                className="input"
                type={showPassword ? 'text' : 'password'}
                autoComplete={autoComplete}
                endAdornment={
                    <InputAdornment position="end">
                        <IconButton
                            aria-label="toggle password visibility"
                            onClick={handleClickShowPassword}
                            edge="end"
                        >
                            {showPassword ? <VisibilityOff /> : <Visibility />}
                        </IconButton>
                    </InputAdornment>
                }
                label="Password"
            />
        </FormControl>
    )
}
